<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    :multiple="multiple"
    placeholder="请选择物流"
    idKey="LogisticsId"
    labelKey="LogisticsName"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/logistics").default,
      data: [],
    };
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.list({ Status: 1 }).then((res) => {
          this.data = res.Data;
          resolve({ Data: res.Data });
        });
      });
    },
    getData() {
      return this.data;
    },
  },
};
</script>

